import * as api from "../apis/ETLRunsApi";
import {
  useQuery,
  useQueryClient,
  keepPreviousData,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getPaginatedETLRunsQueryOptions = ({
  filterText,
  filterStartDate,
  filterEndDate,
  filterIsCompleted,
  filterHasError,
  filterDeleted,
  sortBy,
  page,
  nbDocsPerPage,
}) =>
  queryOptions({
    queryKey: [
      "ETLRuns",
      filterText,
      filterStartDate,
      filterEndDate,
      filterIsCompleted,
      filterHasError,
      filterDeleted,
      sortBy,
      page,
      nbDocsPerPage,
    ],
    queryFn: () =>
      api.getPaginatedETLRuns({
        filterText,
        filterStartDate,
        filterEndDate,
        filterIsCompleted,
        filterHasError,
        filterDeleted,
        sortBy,
        page,
        nbDocsPerPage,
      }),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: "always",
    
  });

export const getETLRunQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["ETLRun", id],
    queryFn: () => api.getETLRun(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // we try to find the ETLRun in one of the "ETLRuns" queries
      let found;

      queryClient.getQueriesData({ queryKey: ["ETLRuns"] }).forEach((query) => {
        const data = query[1]?.data;
        if (data) {
          data.forEach((ETLRun) => {
            if (ETLRun.id === id) {
              found = ETLRun;
              queryKey = query[0];
            }
          });
        }
      });

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetPaginatedETLRuns = ({
  filterText,
  filterStartDate,
  filterEndDate,
  filterIsCompleted,
  filterHasError,
  filterDeleted,
  sortBy,
  page,
  nbDocsPerPage,
}) =>
  useQuery(
    getPaginatedETLRunsQueryOptions({
      filterText,
      filterStartDate,
      filterEndDate,
      filterIsCompleted,
      filterHasError,
      filterDeleted,
      sortBy,
      page,
      nbDocsPerPage,
    })
  );

export const useGetETLRun = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getETLRunQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetETLRun = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getETLRunQueryOptions(id, queryClient));
};
